import { render } from "./Apartments.vue?vue&type=template&id=5b86b3b8"
import script from "./Apartments.vue?vue&type=script&lang=js"
export * from "./Apartments.vue?vue&type=script&lang=js"
script.render = render

export default script